(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('OfficeDetailController', OfficeDetailController);

    OfficeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Office'];

    function OfficeDetailController($scope, $rootScope, $stateParams, entity, Office) {
        var vm = this;
        vm.office = entity;
        vm.load = function (id) {
            Office.get({id: id}, function(result) {
                vm.office = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:officeUpdate', function(event, result) {
            vm.office = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
